module.exports = function() {
  return new Worker(__webpack_public_path__ + "ac15bce49c63dfa6dcf6.worker.js");
};